import Vue from 'vue';
import DialogStateMixin from '@/helpers/vue_mixins/v2/DialogStateMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ActionButton from '@/components/action_button/Index.vue';
import '@/assets/stylesheets/v2/_deactivation_notice.scss';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
export default Vue.extend({
    components: {
        AppBasicDetails,
        BaseSubtitle,
        ActionButton,
    },
    mixins: [DialogStateMixin, RouterParamsAppMixin],
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        pendingCount: {
            type: String,
            default: '',
            required: true,
        },
        plan: {
            type: String,
            default: 'free',
            required: true,
        },
    },
    computed: {
        warningText() {
            return ('Starting November 1, 2020, all pending orders will be automatically marked as confirmed after 10 days.' +
                ' To avoid confirming unwanted orders, kindly cancel it via Order Tracker.');
        },
        hideWarningText() {
            let clas = '.d.none';
            if (this.plan === 'free') {
                clas = '';
            }
            return clas;
        },
    },
    created() {
        this.toggle = this.show;
    },
    methods: {
        goToOrderTracker() {
            this.$router.push({
                name: 'ecommerce-orders-by-status',
                params: { status: 'pending' },
            });
            this.hideDialog();
        },
    },
    render(createElement) {
        const self = this;
        const cardContent = () => {
            return createElement('v-card', { class: 'card pa-4' }, [
                createElement('v-btn', { props: { icon: true }, class: 'close', on: { click: self.hideDialog } }, [createElement('v-icon', ['close'])]),
                createElement('v-layout', { class: 'column align-center justify-center' }, [
                    createElement('v-flex', { class: 'shrink mt-5 mb-4' }, [
                        createElement('v-img', {
                            props: {
                                src: require('@/assets/images/pending-orders.svg'),
                                height: 172,
                                width: 154,
                            },
                        }),
                    ]),
                    createElement('v-flex', { class: 'mb-4' }, [
                        createElement('base-subtitle', { props: { text: 'Pending Orders' } }),
                    ]),
                    createElement('v-flex', { props: { fontSize14: true } }, [
                        createElement('base-text', {
                            props: {
                                text: 'You still have '.concat(self.pendingCount).concat(' orders to confirm.'),
                            },
                            class: 'text-xs-center',
                        }),
                    ]),
                    createElement('v-flex', { props: { fontSize14: true } }, [
                        createElement('base-text', {
                            props: {
                                text: self.warningText,
                            },
                            attrs: {
                                id: 'warningText',
                                class: self.hideWarningText,
                            },
                            class: 'text-xs-center',
                        }),
                    ]),
                    createElement('v-flex', { class: 'mb-3' }, [
                        createElement('v-layout', [
                            createElement('v-flex', [
                                createElement('action-button', {
                                    props: { orangeTheme: true, submit: true },
                                    on: { wasClicked: self.goToOrderTracker },
                                    attrs: { id: 'viewPendingOrders' },
                                }, ['See Pending Orders']),
                            ]),
                        ]),
                    ]),
                ]),
            ]);
        };
        return createElement('v-dialog', {
            props: {
                value: self.toggle,
                width: 400,
                persistent: true,
                contentClass: 'deactivation-notice',
            },
        }, [cardContent()]);
    },
});
